import { Dialog } from "primereact/dialog";
import { eachDayOfInterval, format } from "date-fns";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { ILeadReq } from "../../../models/BaseModel";
import { Fetch } from "../../../shared/Fetch";
import { JVCheck } from "../../../shared/JVCheck";

export interface IReqActivity {
    uniqueId: number
    id?: number
    name: string
    startTime: number
    duration: number
    activityId: number
    activityTypeId: number
    desc?: string
    isIncluded: boolean
}

interface IProps {
    req: ILeadReq
    open: boolean
    onSuccess: () => void
    onHide: () => void
    toast: any
}

export const ItineraryReq = (props: IProps) => {
    const [activities, setActivities] = useState<IReqActivity[]>();
    const [loading, setLoading] = useState(false);

    const getStayDates = (start: Date, end: Date) => eachDayOfInterval({ start, end });
    const getCheckinSlot = (date: Date) => {
        const hour = date.getHours();
        if (hour < 11) return 'morning';
        if (hour < 15) return 'afternoon';
        return 'evening';
    };
    const loadActivities = async (checkIn: 'morning' | 'afternoon' | 'evening', packageId: number) => {
        setLoading(true);
        const response = await Fetch("itinerary/GetActivityList", "GET", null, `checkIn=${checkIn}&packageId=${packageId}`, null);
        if (response) {
            const d: IReqActivity[] = await response.json();
            setActivities(d);
            if (props.open && d.length === 0) {
                props.toast.current.show({ severity: 'warn', detail: `There has no activity in ${props.req.packageName} package with ${checkIn} checkIn`, life: 3000 });
            }
        }
        setLoading(false);
    }

    function onHide() {
        props.onHide();
        setActivities(undefined);
    }

    useEffect(() => {
        if (props.req.checkin && props.req.packageId) {
            if (props.req.itinerary && props.req.itinerary.length > 0) {
                setActivities(props.req.itinerary);
            } else {
                const slot = getCheckinSlot(new Date(props.req.checkin));
                loadActivities(slot, props.req.packageId);
            }
        }
    }, [props.req.id, props.req.checkin, props.req.packageId]);

    const onCheckChange = (a: IReqActivity) => {
        setActivities(prev => {
            return prev?.map(act => act.uniqueId === a.uniqueId ? { ...act, isIncluded: !a.isIncluded } : act);
        });
    }

    async function onSubmit() {
        setLoading(true);
        if (!activities || activities.length === 0) {
            setLoading(false);
            return;
        }
        const response = await Fetch(`leadreq/itinerary/${props.req.id}`, "PUT", activities, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Itinerary activities saved successfully', life: 3000 });
            props.onSuccess();
            setActivities(undefined);
        }
        setLoading(false);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header={`Choose Activities`} modal className="p-fluid" onHide={onHide}>
            {props.req.checkin && props.req.checkout && activities && (() => {
                const dates = getStayDates(new Date(props.req.checkin), new Date(props.req.checkout));
                return <>{dates.map((day, i) => (
                    <div className="p-2" key={i}>
                        <span className="underline font-bold">Day: {i + 1} - {format(day, 'd MMM yyyy')}({format(day, 'EEEE')})</span>
                        {activities.filter(a => a.startTime > ((i) * (60 * 24)) && a.startTime < ((i + 1) * (60 * 24)))
                            .sort((a, b) => (a.startTime) - (b.startTime)).map((a, _i) => {
                                return <div className="py-2" key={_i}>
                                    <span onClick={() => onCheckChange(a)}><JVCheck defaultValue={a.isIncluded} /></span>
                                    <span className="px-4">{(() => {
                                        const hours = Math.floor(a.startTime / 60);
                                        const mins = a.startTime % 60;
                                        const date = (new Date()).setHours(hours, mins, 0, 0);
                                        return format(date, 'hh:mm a');
                                    })()} | {a.name}</span>
                                </div>
                            })}
                    </div>
                ))}
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button style={{ width: '100px' }} loading={loading} label="SAVE" onClick={onSubmit} type="button" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </>
            })()}
        </Dialog>
    );
}